<div class="workflow-report-popup">
<c-auto-form config="workflowReportConfigCtrl.autoFormConfig"></c-auto-form>

<div class="popup-button-content">
    <div>
        <span ng-if="!workflowReportConfigCtrl.isGenerateReport"><button class="popup-msg-button btn-primary" ng-click="workflowReportConfigCtrl.ok()"><span>{{'save'|translate}}</span></button></span>
        <span ng-if="!workflowReportConfigCtrl.isGenerateReport && workflowReportConfigCtrl.showRemove"><button class="popup-msg-button" ng-click="workflowReportConfigCtrl.remove()"><span>{{'remove'|translate}}</span></button></span>
        <span ng-if="!workflowReportConfigCtrl.isGenerateReport"><button class="popup-msg-button" ng-click="workflowReportConfigCtrl.cancel()"><span>{{'popup.cancel'|translate}}</span></button></span>
        <span ng-if="workflowReportConfigCtrl.isGenerateReport"><button class="popup-msg-button" ng-click="workflowReportConfigCtrl.cancel()"><span>{{'close'|translate}}</span></button></span>
    </div>
</div>
</div>